const urlRegex =
  /(((https?:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/=\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w\-]*))?)/
const protocols = ['http:', 'https:']

export class UrlCleaner {
  constructor(text) {
    if (typeof text === 'string') {
      this.text = text.trim()
    } else {
      this.text = ''
    }
    this.url = this.#clean()
  }

  get isEmpty() {
    return this.text === ''
  }

  get isValid() {
    if (this.isEmpty) return false

    try {
      const uri = new URL(this.url)
      return protocols.includes(uri.protocol)
    } catch (e) {
      return false
    }
  }

  #clean() {
    if (this.isEmpty) return ''

    // Word by word: a link ends at the first space, what follows is the
    // sharer's text ("https://… sur Amazon"), not the end of the path.
    for (const word of this.text.split(/\s+/)) {
      // Only encode what isn't already: a pasted link often carries %XX escapes.
      const results = encodeURI(word).replace(/%25([0-9A-F]{2})/gi, '%$1').match(urlRegex)
      if (results) return results[0]
    }

    return ''
  }
}
